import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function saveFees(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.proxyRequestSimultaneous
  const request = {
    requests: data.map(body => {
      return {
        method: 'post',
        url: urls.saveFees,
        body,
      }
    }),
  }
  const response = await Network.sendPostRequest(url, request)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    let atLeastOneUpdated = false
    let allUpdateDone = true
    Object.keys(response.response).forEach(key => {
      const isCreated = response.response[key]?.body?.statusCode == 200
      if (isCreated) atLeastOneUpdated = true
      if (!isCreated) allUpdateDone = false
    })
    return {
      atLeastOneUpdated,
      allUpdateDone,
      statusCode: allUpdateDone,
      success: allUpdateDone,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { saveFees }
